<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';
    import utilsService from '@/services/core/utils.service';
    import httpService from '@/services/core/http.service';
    import ButtonSpinner from '@/components/shared/ButtonSpinner';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import DataSource from 'devextreme/data/data_source';

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal,
            ButtonSpinner,
            DxSelectBox
        },
        data() {
            return {
                isLoading: 0,
                entitiesLoaded: true,
                entityTypes: [
                    {
                        id: 0,
                        name: 'Select a type...'
                    },
                    {
                        id: 1,
                        name: 'User'
                    },
                    {
                        id: 2,
                        name: 'Battery'
                    },
                    {
                        id: 3,
                        name: 'Well'
                    },
                    {
                        id: 4,
                        name: 'Injection Well'
                    },
                    {
                        id: 5,
                        name: 'Collection Point'
                    }
                ],
                entitiesDs: {},
                item: {},
                selectedEntity: null
            };
        },
        methods: {
            close() {
                modalService.closeModal();
            },
            save() {
                let dto = utilsService.toJS(this.item);
                dto.entityName = this.selectedEntity.name;

                if (dto.entityType == 3 || dto.entityType == 4) dto.entityName = this.selectedEntity.name.split(' - ')[0];

                dto.entityId = this.selectedEntity.id;
                const url = `companies/billable-item-ignored`;

                this.isLoading++;
                httpService
                    .post(url, dto)
                    .then(() => {
                        utilsService.showToast('Entity saved');
                        this.modalData.onSuccess && this.modalData.onSuccess();
                        this.close();
                    })
                    .finally(() => this.isLoading--);
            },
            loadEntities() {
                if (this.item.entityType == 0) return;

                this.selectedEntity = null;

                this.entitiesLoaded = false;

                const url = `companies/${this.item.companyId}/billable-entities/${this.item.entityType}`;

                httpService
                    .get(url)
                    .then(data => {
                        this.entitiesDs = new DataSource({
                            store: data,
                            paginate: true,
                            pageSize: 10
                        });
                    })
                    .finally(() => (this.entitiesLoaded = true));
            }
        },
        mounted() {
            this.item = utilsService.toJS(this.modalData.item);
        }
    };
</script>

<template>
    <Modal>
        <form class="gsb-form" @submit.prevent="save">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Ignore Entity</h3>
                </div>
                <div class="modal-body">
                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Entity Type</label>
                        <div class="col-sm">
                            <select class="form-select" id="entityType" v-model="item.entityType" @change="loadEntities" required>
                                <option v-for="entityType in entityTypes" :value="entityType.id" :key="entityType.id">
                                    {{ entityType.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Entity</label>
                        <div class="col-sm">
                            <DxSelectBox
                                v-model="selectedEntity"
                                :data-source="entitiesDs"
                                display-expr="name"
                                :search-enabled="true"
                                search-mode="contains"
                                search-expr="name"
                                :search-timeout="200"
                                drop-down-button-template="loadIcon"
                            >
                                <template #loadIcon="{}">
                                    <div>
                                        <span v-show="!entitiesLoaded" class="spinner-border spinner-border-sm me-2" role="status"></span>
                                    </div>
                                </template>
                            </DxSelectBox>
                        </div>
                    </div>

                    <div class="row">
                        <label class="col-sm-3 col-form-label">Reason</label>
                        <div class="col-sm">
                            <textarea id="reason" class="form-control" v-model="item.reason" rows="2" required />
                        </div>
                    </div>
                </div>

                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn" @click="close">Close</button>
                    <ButtonSpinner :isLoading="isLoading" />
                </div>
            </div>
        </form>
    </Modal>
</template>

<style lang="scss" scoped>
    .dx-selectbox {
        height: 32px;
        line-height: 1.3;
        font-size: 13px;
    }
</style>
